import { handleActions } from 'redux-actions-helpers'
import * as actions from './actions'
import { InitialState } from './types'
import { checkProfileFilled } from '../../utils/helpers'

const initialState: InitialState = {
  newAchievements: null,
  newAchievementsIsFetching: false,
  markAchievementIsFetching: false,
  referralLink: null,
  selectedAchievement: null,
  authorizationIsFetching: false,
  logOutIsFetching: false,
  profileIsFetching: false,
  checkFirstModuleIsProcess: false,
  modalQuestionnaireIsOpen: false,
  currentCourseTitle: '',
  isProcessSave: false,
  isProcessReferralLink: false,
  isProcessUploadAchievementScreenshot: false,
  isProcessShareAchievementScreenshot: false,
  isProcessChangeProfileRole: false,
  isProcessEmailInvite: false,
  achievementUrlImage: '',
  isProcessSendInvite: '',
  sendInviteComplete: false,
  viewedContestWorks: [],
  certificates: [],
  isFetchingCertificates: false,
  error: '',
}

export default handleActions(
  {
    [actions.signIn]: state => {
      return {
        ...state,
        authorizationIsFetching: true,
        error: initialState.error,
      }
    },
    [actions.signInSuccess]: state => {
      return {
        ...state,
        authorizationIsFetching: false,
      }
    },
    [actions.signInFailure]: (state, action) => {
      return {
        ...state,
        authorizationIsFetching: false,
        error: action.error,
      }
    },
    [actions.signOut]: state => {
      return {
        ...state,
        logOutIsFetching: true,
      }
    },
    [actions.signOutSuccess]: state => {
      return {
        ...state,
        logOutIsFetching: false,
      }
    },
    [actions.signOutFailure]: (state, action) => {
      return {
        ...state,
        logOutIsFetching: false,
        error: action.error,
      }
    },
    [actions.fetchProfile]: state => {
      return {
        ...state,
        profileIsFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchProfileSuccess]: (state, action) => {
      return {
        ...state,
        profile: action.result,
        profileIsFetching: initialState.profileIsFetching,
      }
    },
    [actions.fetchProfileFailure]: (state, action) => {
      return {
        ...state,
        profileIsFetching: initialState.profileIsFetching,
        error: action.error,
      }
    },
    [actions.fetchNewAchievements]: state => {
      return {
        ...state,
        newAchievementsIsFetching: true,
        error: initialState.error,
      }
    },
    [actions.fetchNewAchievementsSuccess]: (state, action) => {
      return {
        ...state,
        newAchievements: action.result,
        newAchievementsIsFetching: initialState.newAchievementsIsFetching,
      }
    },
    [actions.fetchNewAchievementsFailure]: (state, action) => {
      return {
        ...state,
        newAchievementsIsFetching: initialState.newAchievementsIsFetching,
        error: action.error,
      }
    },
    [actions.markViewedAchievement]: state => {
      return {
        ...state,
        markAchievementIsFetching: true,
      }
    },
    [actions.markViewedAchievementSuccess]: state => {
      return {
        ...state,
        markAchievementIsFetching: initialState.markAchievementIsFetching,
        newAchievements: initialState.newAchievements,
      }
    },
    [actions.markViewedAchievementFailure]: (state, action) => {
      return {
        ...state,
        markAchievementIsFetching: initialState.markAchievementIsFetching,
        error: action.error,
      }
    },
    [actions.setSelectedAchievement]: (state, action) => {
      return {
        ...state,
        selectedAchievement: action.achieve,
      }
    },
    [actions.checkFirstModuleComplete]: state => {
      return {
        ...state,
        checkFirstModuleIsProcess: true,
      }
    },
    [actions.checkFirstModuleCompleteSuccess]: (state, action) => {
      return {
        ...state,
        checkFirstModuleIsProcess: false,
        modalQuestionnaireIsOpen:
          !checkProfileFilled(state.prfile) && action.result,
      }
    },
    [actions.checkFirstModuleCompleteFailure]: state => {
      return {
        ...state,
        checkFirstModuleIsProcess: false,
      }
    },
    [actions.saveProfile]: state => {
      return {
        ...state,
        isProcessSave: true,
      }
    },
    [actions.saveProfileSuccess]: state => {
      return {
        ...state,
        isProcessSave: initialState.isProcessSave,
        modalQuestionnaireIsOpen: false,
      }
    },
    [actions.saveProfileFailure]: (state, action) => {
      return {
        ...state,
        isProcessSave: initialState.isProcessSave,
        error: action.error,
      }
    },
    [actions.fetchReferralLink]: state => {
      return {
        ...state,
        referralLink: null,
        isProcessReferralLink: true,
      }
    },
    [actions.fetchReferralLinkSuccess]: (state, action) => {
      return {
        ...state,
        referralLink: action.result,
        isProcessReferralLink: false,
      }
    },
    [actions.fetchReferralLinkFailure]: (state, action) => {
      return {
        ...state,
        isProcessReferralLink: false,
        error: action.error,
      }
    },
    [actions.sendParentInvite]: (state, action) => {
      return {
        ...state,
        isProcessSendInvite: action.parent,
        sendInviteComplete: false,
      }
    },
    [actions.sendParentInviteSuccess]: state => {
      return {
        ...state,
        isProcessSendInvite: '',
        sendInviteComplete: true,
      }
    },
    [actions.sendParentInviteFailure]: (state, action) => {
      return {
        ...state,
        isProcessSendInvite: '',
        sendInviteComplete: false,
        error: action.error,
      }
    },
    [actions.sendParentInviteDestroy]: state => {
      return {
        ...state,
        isProcessSendInvite: '',
        sendInviteComplete: false,
      }
    },
    [actions.sendEmailInvite]: state => {
      return {
        ...state,
        isProcessFriendInvite: true,
      }
    },
    [actions.sendEmailInviteSuccess]: state => {
      return {
        ...state,
        isProcessFriendInvite: false,
      }
    },
    [actions.sendEmailInviteFailure]: (state, action) => {
      return {
        ...state,
        isProcessFriendInvite: false,
        error: action.error,
      }
    },
    [actions.uploadAchievementScreenshot]: state => {
      return {
        ...state,
        isProcessUploadAchievementScreenshot: true,
      }
    },
    [actions.uploadAchievementScreenshotSuccess]: state => {
      return {
        ...state,
        isProcessUploadAchievementScreenshot: false,
      }
    },
    [actions.uploadAchievementScreenshotFailure]: (state, action) => {
      return {
        ...state,
        isProcessUploadAchievementScreenshot: false,
        error: action.error,
      }
    },
    [actions.sendEmailInvite]: state => {
      return {
        ...state,
        isProcessEmailInvite: true,
      }
    },
    [actions.sendEmailInviteSuccess]: state => {
      return {
        ...state,
        isProcessEmailInvite: false,
      }
    },
    [actions.sendEmailInviteFailure]: (state, action) => {
      return {
        ...state,
        isProcessEmailInvite: false,
        error: action.error,
      }
    },
    [actions.shareAchievementScreenshot]: state => {
      return {
        ...state,
        achievementUrlImage: '',
        isProcessShareAchievementScreenshot: true,
      }
    },
    [actions.shareAchievementScreenshotSuccess]: (state, action) => {
      return {
        ...state,
        achievementUrlImage: action.image,
        isProcessShareAchievementScreenshot: false,
      }
    },
    [actions.shareAchievementScreenshotFailure]: (state, action) => {
      return {
        ...state,
        achievementUrlImage: '',
        isProcessShareAchievementScreenshot: false,
        error: action.error,
      }
    },
    [actions.clearReferralLink]: state => {
      return {
        ...state,
        referralLink: null,
      }
    },
    [actions.clearError]: state => {
      return {
        ...state,
        error: initialState.error,
      }
    },
    [actions.closeModalQuestionnaire]: state => {
      return {
        ...state,
        modalQuestionnaireIsOpen: false,
      }
    },
    [actions.setCurrentCourseTitle]: (state, action) => {
      return {
        ...state,
        currentCourseTitle: action.title,
      }
    },
    [actions.setViewedContestWork]: (state, action) => {
      const checkViewedWorks = Array.isArray(state.viewedContestWorks)
      if (checkViewedWorks) {
        state.viewedContestWorks.push(action.id)
      }
      return {
        ...state,
        viewedContestWorks: checkViewedWorks
          ? state.viewedContestWorks
          : [action.id],
      }
    },
    [actions.changeProfileRole]: state => {
      return {
        ...state,
        isProcessChangeProfileRole: true,
      }
    },
    [actions.changeProfileRoleSuccess]: state => {
      return {
        ...state,
        isProcessChangeProfileRole: false,
      }
    },
    [actions.changeProfileRoleFailure]: (state, action) => {
      return {
        ...state,
        isProcessChangeProfileRole: false,
        error: action.error,
      }
    },
    [actions.fetchCertificates]: state => {
      return {
        ...state,
        isFetchingCertificates: true,
        error: initialState.error,
      }
    },
    [actions.fetchCertificatesSuccess]: (state, action) => {
      return {
        ...state,
        certificates: action.result,
        isFetchingCertificates: initialState.profileIsFetching,
      }
    },
    [actions.fetchCertificatesFailure]: (state, action) => {
      return {
        ...state,
        isFetchingCertificates: initialState.profileIsFetching,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
